module.exports = __webpack_public_path__ + "img/books.ffe3df66.png";